<template>
  <svg
    id="share"
    fill="#4d48e8"
    style="height: 24px; width: 24px; margin-left: 4px; display:inline-block;"
    enable-background="new 0 0 300 300"
    height="512"
    viewBox="0 0 300 300"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m224.172 254h-148.344c-16.445 0-29.828-13.383-29.828-29.828v-148.344c0-16.445 13.383-29.828 29.828-29.828h66.172c4.422 0 8 3.578 8 8s-3.578 8-8 8h-66.172c-7.625 0-13.828 6.203-13.828 13.828v148.344c0 7.625 6.203 13.828 13.828 13.828h148.344c7.625 0 13.828-6.203 13.828-13.828v-66.172c0-4.422 3.578-8 8-8s8 3.578 8 8v66.172c0 16.445-13.383 29.828-29.828 29.828z"
    />
    <g fill="#4d48e8">
      <path
        d="m246 118c-4.422 0-8-3.578-8-8v-48h-48c-4.422 0-8-3.578-8-8s3.578-8 8-8h56c4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8z"
      />
      <path
        d="m166 142c-2.047 0-4.094-.781-5.656-2.344-3.125-3.125-3.125-8.188 0-11.312l80-80c3.125-3.125 8.188-3.125 11.312 0s3.125 8.188 0 11.312l-80 80c-1.562 1.563-3.609 2.344-5.656 2.344z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LinkIcon',
};
</script>
